import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import classNames from 'classnames';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';
import PropTypes from 'prop-types';
import PopUp from '../PopUp';

const itemSource = {
  beginDrag(props) {
    return {
      item: props.item
    };
  }
};

const collect = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

class DragItem extends Component {
  dragItemClasses = () => {
    const { correct, hasValidated, isFinalAttempt } = this.props;

    return classNames(
      {
        'drag-item--error': hasValidated && !correct && isFinalAttempt,
        'drag-item--success': hasValidated && correct && isFinalAttempt
      },
      'drag-item'
    );
  };

  handleDragItemClick = (e, item) => {
    e.preventDefault();

    this.props.keyboardDND(item);
  };

  handleMove = (e, item, dropTarget) => {
    this.props.handleDrop(item, dropTarget);
  };

  render() {
    const { correct, hasValidated, item, isFinalAttempt } = this.props;

    if (hasValidated) {
      return (
        <div className={this.dragItemClasses(hasValidated, correct)}>
          <span className="drag-item__icon">
            <svg focusable="false">
              <use xlinkHref={`${icons}#grip`} />
            </svg>
          </span>
          <p className="drag-item__text">{item}</p>
          {isFinalAttempt && (
            <span className="drag-item__icon-feedback">
              <svg focusable="false">
                <use xlinkHref={`${icons}#${correct ? 'check' : 'x'}`} />
              </svg>
            </span>
          )}
        </div>
      );
    } else {
      const hasPopup = this.props.visibleDropMenu === item;

      return this.props.connectDragSource(
        <div className={this.dragItemClasses(hasValidated, correct)}>
          <span className="drag-item__icon">
            <svg focusable="false">
              <use xlinkHref={`${icons}#grip`} />
            </svg>
          </span>
          <a
            className="drag-item__text"
            href=""
            onClick={e => this.handleDragItemClick(e, item)}
          >
            {item}
          </a>
          {hasPopup && (
            <PopUp
              parent={item}
              onSelect={this.handleMove}
              menuItems={this.props.dropZones}
              turnOffPopUp={this.props.keyboardDND}
            />
          )}
        </div>
      );
    }
  }
}

DragItem.propTypes = {
  item: PropTypes.string.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  hasValidated: PropTypes.bool,
  correct: PropTypes.bool,
  keyboardDND: PropTypes.func.isRequired,
  visibleDropMenu: PropTypes.string,
  dropZones: PropTypes.array.isRequired,
  handleDrop: PropTypes.func.isRequired
};

export default DragSource('DnD', itemSource, collect)(DragItem);



// WEBPACK FOOTER //
// ../core/src/components/DragAndDrop/DragSource.js